import { render, staticRenderFns } from "./DeliverydateoverviewPage.vue?vue&type=template&id=e87bf93c"
import script from "./DeliverydateoverviewPage.vue?vue&type=script&lang=js"
export * from "./DeliverydateoverviewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports